import React, {useRef, useState} from "react";
import {formatDate, hasAtLeastOnePermission, hasPermission} from "../../../sc-utilities";
import {IconButton, Tooltip, Typography, withStyles} from "@material-ui/core";
import {Info} from "@material-ui/icons";
import {connect} from "react-redux";
import PlanVersionsList from "./PlanVersionsList";
import InfoDialog from "../../BillingAccount/Details/Plans/InfoDialog";
import {openInfo} from "../../BillingAccount/Details/Plans";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='chipActive']": {
            color: theme.palette.success.dark
        },
        "[class*='chipPrepared']": {
            color: theme.palette.warning.dark,
        },
        "[class*='chipInactive']": {
            color: theme.palette.error.dark
        }
    },
    chipActive: {
        color: theme.palette.success.dark
    },
    chipPrepared: {
        color: theme.palette.warning.dark,
    },
    chipInactive: {
        color: theme.palette.error.dark
    }
});

const PlanVersions = (props) => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;

    const [infoPlans, setInfoPlans] = useState({ data: [], description: '', name: '', priceList: [], min: 0, max: 0 })
    const [open, setOpen] = useState(false);

    let visible = columns && columns['PlanVersions'];
    const getUsedFor = (PrepaidAllowed, PostpaidAllowed) => {
        return PrepaidAllowed && PostpaidAllowed ? translations['both'] || 'Both' : PrepaidAllowed && !PostpaidAllowed ? translations['prepaid_only'] || 'Prepaid only' : PostpaidAllowed && !PrepaidAllowed ? translations['postpaid_only'] || 'Postpaid only' : translations['none'] || 'None'
    };

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'plan_versions_load') ?
                    <Tooltip key={`Edit-plan-version-${rowData.PlanID}`} title={translations["plan_version_details"] || "Plan version details"}>
                        <IconButton
                            id={`edit_plan_version_${rowData.PlanID}`}
                            component='div'
                            onClick={() => openInfo(rowData, setInfoPlans, setOpen, translations)}
                        >
                            <Info />
                        </IconButton>
                    </Tooltip>
                    : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["used_for"] || 'Used for', field: 'UsedFor',
            hidden: visible ? visible['UsedFor'] : false,
            lookup: { 'both': translations['both'] || 'Both', 'prepaid_only': translations['prepaid_only'] || 'Prepaid only', 'postpaid_only': translations['postpaid_only'] || 'Postpaid only', 'none': translations['none'] || 'None' },
            defaultFilter: ['both', 'prepaid_only', 'postpaid_only', 'none'],
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{getUsedFor(rowData.PrepaidAllowed, rowData.PostpaidAllowed)}</Typography>;
            }
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Description ? rowData.Description : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["valid_from"] || 'Valid from', field: 'ValidFrom',
            hidden: visible ? visible['ValidFrom'] : false,
            type: 'date',
            cellStyle: { minWidth: 150, maxWidth: 150 },
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ValidFrom ? formatDate(rowData.ValidFrom) : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["valid_to"] || 'Valid to', field: 'ValidTo',
            hidden: visible ? visible['ValidTo'] : false,
            type: 'date',
            cellStyle: { minWidth: 150, maxWidth: 150 },
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ValidTo ? formatDate(rowData.ValidTo) : translations['date_not_set'] || 'Expiration date not set'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, [
        "plan_versions_load"
    ])) {
        tableColumns.shift();
    }

    return (
        <>
            <div className={classes.root}>
                {hasPermission(permissions, 'plan_versions_list') ?
                    <PlanVersionsList
                        tableColumns={tableColumns}
                        tableRef={tableRef}
                    /> : null}
            </div>
            <InfoDialog open={open} infoPlans={infoPlans} translations={translations} handleClose={() => setOpen(false)} />
        </>
    );
}

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(PlanVersions));